














































































































































































































































import axios, { CancelTokenSource } from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoUserFilter from '@/components/Organisms/co-user-filter/CoUserFilter.vue';
import type {
    UserCreatedAtFilterValue,
    UserCustomFieldDefinition,
    UserFilterOption,
    UserFilterValue,
} from '@/components/Organisms/co-user-filter/models';
import type {
    FilterableCommunityMemberUser,
    UserFilterOrderDirection,
    UserFilter,
    UsersFilterRequest,
    UsersFilterResponse,
} from '@/types/MemberFilter';
import { formattedDate } from '@/language/dateTimeFormatter.ts';
import EventBus from '../../../../eventBus';

import CoUserCreateAdminModal from '../../../../components/Organisms/co-user-create-admin-modal/CoUserCreateAdminModal.vue';
import CoDate from '../../../../components/Molecules/co-date/CoDate.vue';
import CoDownloadAsCsv from '../../../../components/Organisms/co-download-as-csv/CoDownloadAsCsv.vue';
import CoUserInvite from '../../../../components/Organisms/co-user-invite/CoUserInvite.vue';
import CoTable from '../../../../components/Molecules/co-table/CoTable.vue';
import CoTableColumnSelector from '../../../../components/Molecules/co-table-column-selector/CoTableColumnSelector.vue';
import CoInput from '../../../../components/Molecules/co-input/CoInput.vue';

const MEMBERS_FILTER_PAGE_SIZE = 100;
const MEMBERS_SEARCH_FIELD_KEY = 'search';
const MEMBERS_CREATED_AT_FIELD_KEY = 'CreatedAt';
const MEMBERS_STATUS_FIELD_KEY = 'Status';
const MEMBERS_CURRENT_PLAN_ID_FIELD_KEY = 'CurrentPlanID';
const DEFAULT_MEMBER_ORDER_BY_FIELD_KEY = 'CreatedAt';
const DEFAULT_MEMBER_ORDER_DIRECTION: UserFilterOrderDirection = 'DESC';
const MEMBERS_TABLE_PREFERENCE_KEY = 'admin-community-members-v2';
const MEMBERS_SELECTED_COLUMNS_PREFERENCE_KEY = 'selectedFieldKeys';
const MEMBERS_CSV_EXPORT_BATCH_SIZE = 100;
const MEMBERS_CSV_EXPORT_PROGRESS_DELAY_MIN_MS = 1000;
const MEMBERS_CSV_EXPORT_PROGRESS_DELAY_MAX_MS = 2000;
const DEFAULT_MEMBER_COLUMN_KEYS = [
    'object.Profile.Name',
    'object.Email',
    'object.CreatedAt',
    'object.UpdatedAt',
    'object.LastActivity',
    'object.Status',
    'object.CurrentPlanName',
    'object.CurrentPlanUpgradeNames',
    'object.CurrentPlanStart',
    'object.CurrentPlanEnd',
    'object.UpcomingPlanName',
    'object.UpcomingPlanUpgradeNames',
    'object.UpcomingPlanStart',
];
const DEFAULT_MEMBER_FILTERS: UserFilterValue = {
    search: '',
    createdAt: null,
    status: null,
    currentPlanId: null,
    moreFilters: [],
};

interface MembersTableRow {
    object: FilterableCommunityMemberUser;
    customFieldValues: Record<string, string>;
}

interface TableOrderEvent {
    key: string;
    asc: boolean;
}

interface SharedMembersViewState {
    userFilters: UserFilterValue;
    orderByFieldKey: string;
    orderDirection: UserFilterOrderDirection;
}

interface CustomMemberField {
    ID?: string;
    id?: string;
    Identifier?: string;
    identifier?: string;
    Label?: string;
    label?: string;
    InputType?: 'text' | 'number' | 'date' | 'boolean' | 'select' | 'multiselect' | 'link';
    // eslint-disable-next-line camelcase
    data_type?: 'text' | 'number' | 'date' | 'boolean' | 'select' | 'multiselect' | 'link';
    Value?: string | number | boolean | null;
    value?: string | number | boolean | null;
    SortOrder?: number;
    // eslint-disable-next-line camelcase
    sort_order?: number;
    Options?: string[];
    OptionsValues?: string[];
    // eslint-disable-next-line camelcase
    options_values?: string[];
}

interface TableColumnDefinition {
    key: string;
    title: string;
    style?: string;
    notSortable?: boolean;
}

interface CustomFieldListItem {
    object?: CustomMemberField;
}

interface CsvExportColumnDefinition {
    sourceKey: string;
    csvKey: string;
}

export default {
    name: 'Members',
    components: {
        CoDate,
        CoUserCreateAdminModal,
        CoDownloadAsCsv,
        CoUserInvite,
        CoTable,
        CoTableColumnSelector,
        CoInput,
        CoAlert,
        CoUser,
        CoRoundButton,
        CoUserFilter,
    },
    data() {
        return {
            perPage: 15,
            objects: [] as MembersTableRow[],
            ongoingRequest: null as CancelTokenSource | null,
            csvExportLoading: false,
            csvExportProgressCurrent: 0,
            csvExportProgressTotal: 0,
            currentOffset: 0,
            nextOffset: null as number | null,
            previousOffsets: [] as number[],
            planOptions: [] as UserFilterOption[],
            upgradeOptions: [] as UserFilterOption[],
            totalCount: 0,
            orderByFieldKey: DEFAULT_MEMBER_ORDER_BY_FIELD_KEY,
            orderDirection: DEFAULT_MEMBER_ORDER_DIRECTION,
            selectedFieldKeys: DEFAULT_MEMBER_COLUMN_KEYS as string[],
            customFieldDefinitions: [] as UserCustomFieldDefinition[],
            userFilters: cloneDeep(DEFAULT_MEMBER_FILTERS) as UserFilterValue,
            statusTypes: [
                'Active',
                'Pending',
                'Deleted',
                'Suspended',
                'Cancelled',
                'Waiting for approval',
                'Rejected',
                'Guest',
                'Banned',
            ],

            requestLoading: false,
            pagesLoaded: 0,
            takesLonger: false,
            pagesLoading: false,
            preservedTableScrollLeft: 0,
            baseFields: [
                {
                    key: 'object.Profile.Name',
                    title: this.$t('labels.name'),
                    style: 'width: 250px !important',
                    disabled: true,
                    alwaysSelected: true,
                },
                {
                    key: 'object.Profile.BirthDate',
                    title: this.$t('labels.birthdate'),
                    style: 'width: 250px !important',
                },
                {
                    key: 'object.Profile.Salutation',
                    title: this.$t('labels.gender'),
                    style: 'width: 250px !important',
                },
                {
                    key: 'object.Profile.Interests',
                    title: this.$t('labels.aboutme'),
                    style: 'width: 250px !important',
                },
                {
                    key: 'object.Profile.Bio',
                    title: this.$t('labels.headline'),
                },
                {
                    key: 'object.Profile.Tags',
                    title: this.$t('labels.tags'),
                    notSortable: true,
                },
                {
                    key: 'object.Language',
                    title: this.$t('labels.language'),
                },
                {
                    key: 'object.Email',
                    title: this.$t('labels.email'),
                    style: 'width: 250px !important',
                },
                {
                    key: 'object.CreatedAt',
                    title: this.$t('labels.created'),
                },
                {
                    key: 'object.UpdatedAt',
                    title: this.$t('labels.updated'),
                },
                {
                    key: 'object.LastActivity',
                    title: this.$t('labels.lastactivity'),
                },
                {
                    key: 'object.Status',
                    title: this.$t('labels.status'),
                },
                {
                    key: 'object.CurrentPlanName',
                    title: this.$t('labels.plan'),
                },
                {
                    key: 'object.CurrentPlanUpgradeNames',
                    title: `${this.$t('labels.currentplan')} ${this.$t('labels.upgrades')}`,
                    style: 'width: 250px !important',
                },
                {
                    key: 'object.CurrentPlanStart',
                    title: this.$t('labels.currentplanstart'),
                },
                {
                    key: 'object.CurrentPlanEnd',
                    title: this.$t('labels.plancancelledto'),
                },
                {
                    key: 'object.UpcomingPlanName',
                    title: this.$t('labels.planupcoming'),
                },
                {
                    key: 'object.UpcomingPlanUpgradeNames',
                    title: `${this.$t('labels.planupcoming')} ${this.$t('labels.upgrades')}`,
                    style: 'width: 250px !important',
                },
                {
                    key: 'object.UpcomingPlanStart',
                    title: this.$t('labels.planupcomingstart'),
                },
                {
                    key: 'object.Address.Company',
                    title: this.$t('labels.billingcompany'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.Address.AdditionalInfo',
                    title: this.$t('labels.billingadditionalinfo'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.Address.Address',
                    title: this.$t('labels.billingstreet'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.Address.PostalCode',
                    title: this.$t('labels.billingpostalcode'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.Address.City',
                    title: this.$t('labels.billingcity'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.Address.Country',
                    title: this.$t('labels.billingcountry'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.Address.Phone',
                    title: this.$t('labels.billingphone'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.RegistrationAddress.Company',
                    title: this.$t('labels.registrationcompany'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.RegistrationAddress.AdditionalInfo',
                    title: this.$t('labels.registrationadditionalinfo'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.RegistrationAddress.Address',
                    title: this.$t('labels.registrationstreet'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.RegistrationAddress.PostalCode',
                    title: this.$t('labels.registrationpostalcode'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.RegistrationAddress.City',
                    title: this.$t('labels.registrationcity'),
                    style: 'width: 150px !important',
                },
                {
                    key: 'object.RegistrationAddress.Country',
                    title: this.$t('labels.registrationcountry'),
                    style: 'width: 150px !important',
                },
            ] as TableColumnDefinition[],
        };
    },
    computed: {
        defaultSelectedFieldKeys() {
            return DEFAULT_MEMBER_COLUMN_KEYS;
        },
        customFieldColumns(): TableColumnDefinition[] {
            // Build dynamic member columns from the custom field metadata returned on the current page of users.
            return this.sortCustomFields(this.customFieldDefinitions)
                .filter((field) => this.getCustomFieldIdentifier(field))
                .map((field) => ({
                    key: `customFieldValues.${this.getCustomFieldIdentifier(field)}`,
                    title: this.getCustomFieldLabel(field),
                    style: 'width: 200px !important',
                    // notSortable: true,
                }));
        },
        fields() {
            return [...this.baseFields, ...this.customFieldColumns];
        },
        selectedFields() {
            // Keep the rendered table columns aligned with the selector state owned by this page.
            return this.fields.filter((field) => this.selectedFieldKeys.includes(field.key));
        },
        displayedRangeStart() {
            if (this.totalCount === 0) {
                return 0;
            }
            return this.currentOffset + 1;
        },
        displayedRangeEnd() {
            if (this.totalCount === 0) {
                return 0;
            }
            return Math.min(this.currentOffset + this.objects.length, this.totalCount);
        },
        hasNextPage() {
            return this.nextOffset !== null && this.nextOffset > this.currentOffset;
        },
        hasPreviousPage() {
            return this.previousOffsets.length > 0;
        },
        serverPageNumber() {
            if (this.totalCount === 0) {
                return 1;
            }
            return Math.floor(this.currentOffset / this.perPage) + 1;
        },
        totalPages() {
            if (this.totalCount === 0) {
                return 1;
            }
            return Math.ceil(this.totalCount / this.perPage);
        },
    },
    mounted() {
        this.requestLoading = true;
        this.getAllPlans();
        this.getAllPlanUpgrades();
        this.getAllCustomFields();
        // Restore shared filters and ordering from the route before the first request so direct links open with the expected result set.
        this.applySharedMembersViewState(
            typeof this.$route.query.filter === 'string' ? this.$route.query.filter : undefined
        );
        Promise.all([this.initializeSelectedFieldsPreference()]).finally(() => {
            this.listMembers();
        });
        setTimeout(() => {
            this.takesLonger = true;
        }, 5000);
        // track page visit in Intercom for feature usage tracking and targeted messaging
        if (this.$store.state.limits.UserThresholdReached && !this.$store.state.limits.UserLimitReached) {
            EventBus.$emit('intercomTrackEvent', {
                eventName: 'paywall_shown',
            });
            EventBus.$emit('intercomTrackEvent', {
                eventName: 'paywall_shown_user_limit_almost_reached',
            });
        } else if (this.$store.state.limits.UserLimitReached) {
            EventBus.$emit('intercomTrackEvent', {
                eventName: 'paywall_shown',
            });
            EventBus.$emit('intercomTrackEvent', {
                eventName: 'paywall_shown_user_limit_reached',
            });
        }
    },
    watch: {
        '$route.query.filter': function handleRouteFilterChange(nextEncodedFilters: string | undefined) {
            const nextSharedState = this.decodeSharedMembersViewStateFromQuery(nextEncodedFilters);

            if (this.areSharedMembersViewStatesEqual(this.getSharedMembersViewState(), nextSharedState)) {
                return;
            }

            // Keep the page state aligned with shared URLs and browser navigation.
            this.userFilters = nextSharedState.userFilters;
            this.orderByFieldKey = nextSharedState.orderByFieldKey;
            this.orderDirection = nextSharedState.orderDirection;
            this.listMembers(0, { resetHistory: true });
        },
    },
    methods: {
        triggerPaywall() {
            EventBus.$emit('PAYWALL', {
                feature: 'more_members',
            });
        },
        initializeSelectedFieldsPreference() {
            return this.$store
                .dispatch('getTablePreference', {
                    tableKey: MEMBERS_TABLE_PREFERENCE_KEY,
                    preferenceKey: MEMBERS_SELECTED_COLUMNS_PREFERENCE_KEY,
                    fallback: DEFAULT_MEMBER_COLUMN_KEYS,
                })
                .then((persistedSelectedFieldKeys: string[]) => {
                    if (Array.isArray(persistedSelectedFieldKeys) && persistedSelectedFieldKeys.length > 0) {
                        // Restore the table-specific column selection so other tables can persist their own preferences too.
                        this.selectedFieldKeys = persistedSelectedFieldKeys;
                    }
                });
        },
        normalizeUserFilters(filters: UserFilterValue | null | undefined): UserFilterValue {
            return {
                ...cloneDeep(DEFAULT_MEMBER_FILTERS),
                ...(filters || {}),
                moreFilters: Array.isArray(filters?.moreFilters) ? filters.moreFilters : [],
            };
        },
        normalizeSharedMembersViewState(
            sharedState: Partial<SharedMembersViewState> | null | undefined
        ): SharedMembersViewState {
            const nextOrderDirection = sharedState?.orderDirection === 'ASC' ? 'ASC' : DEFAULT_MEMBER_ORDER_DIRECTION;
            return {
                userFilters: this.normalizeUserFilters(sharedState?.userFilters),
                orderByFieldKey: sharedState?.orderByFieldKey || DEFAULT_MEMBER_ORDER_BY_FIELD_KEY,
                orderDirection: nextOrderDirection,
            };
        },
        getSharedMembersViewState(): SharedMembersViewState {
            return this.normalizeSharedMembersViewState({
                userFilters: this.userFilters,
                orderByFieldKey: this.orderByFieldKey,
                orderDirection: this.orderDirection,
            });
        },
        applySharedMembersViewState(encodedSharedState: string | undefined) {
            const nextSharedState = this.decodeSharedMembersViewStateFromQuery(encodedSharedState);
            this.userFilters = nextSharedState.userFilters;
            this.orderByFieldKey = nextSharedState.orderByFieldKey;
            this.orderDirection = nextSharedState.orderDirection;
        },
        encodeSharedMembersViewStateForQuery(sharedState: SharedMembersViewState): string {
            const normalizedJson = JSON.stringify(this.normalizeSharedMembersViewState(sharedState));
            return btoa(unescape(encodeURIComponent(normalizedJson)))
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/g, '');
        },
        decodeSharedMembersViewStateFromQuery(encodedSharedState: string | undefined): SharedMembersViewState {
            if (!encodedSharedState) {
                return this.normalizeSharedMembersViewState(null);
            }

            try {
                const base64 = encodedSharedState.replace(/-/g, '+').replace(/_/g, '/');
                const paddedBase64 = `${base64}${'='.repeat((4 - (base64.length % 4)) % 4)}`;
                const decodedJson = decodeURIComponent(escape(atob(paddedBase64)));
                const parsedState = JSON.parse(decodedJson);

                // Support previously shared filter-only URLs by treating the decoded object as plain user filters.
                if (parsedState && !Object.prototype.hasOwnProperty.call(parsedState, 'userFilters')) {
                    return this.normalizeSharedMembersViewState({
                        userFilters: parsedState,
                    });
                }

                return this.normalizeSharedMembersViewState(parsedState);
            } catch (error) {
                // Invalid shared filter payloads should fall back to the default state instead of breaking the page.
                return this.normalizeSharedMembersViewState(null);
            }
        },
        areSharedMembersViewStatesEqual(
            leftSharedState: SharedMembersViewState,
            rightSharedState: SharedMembersViewState
        ): boolean {
            return (
                this.encodeSharedMembersViewStateForQuery(leftSharedState) ===
                this.encodeSharedMembersViewStateForQuery(rightSharedState)
            );
        },
        syncUserFiltersQuery() {
            const currentSharedState = this.getSharedMembersViewState();
            const defaultSharedState = this.normalizeSharedMembersViewState(null);
            const encodedFilters = this.areSharedMembersViewStatesEqual(currentSharedState, defaultSharedState)
                ? undefined
                : this.encodeSharedMembersViewStateForQuery(currentSharedState);
            const currentEncodedFilters =
                typeof this.$route.query.filter === 'string' ? this.$route.query.filter : undefined;

            if (currentEncodedFilters === encodedFilters) {
                return Promise.resolve();
            }

            // Replace the current route so filter changes stay shareable without polluting the browser history.
            return this.$router
                .replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        filter: encodedFilters,
                    },
                })
                .catch(() => undefined);
        },
        getMembersTableScrollContainer(): HTMLElement | null {
            const membersTable = this.$refs.membersTable as { $el?: HTMLElement } | undefined;
            return membersTable?.$el?.querySelector('.co-table.wrapper') || null;
        },
        preserveMembersTableScrollPosition() {
            const tableScrollContainer = this.getMembersTableScrollContainer();
            this.preservedTableScrollLeft = tableScrollContainer?.scrollLeft || 0;
        },
        restoreMembersTableScrollPosition() {
            this.$nextTick(() => {
                window.requestAnimationFrame(() => {
                    const tableScrollContainer = this.getMembersTableScrollContainer();
                    if (tableScrollContainer) {
                        tableScrollContainer.scrollLeft = this.preservedTableScrollLeft;
                    }
                });
            });
        },
        createMembersRequestSource() {
            return axios.CancelToken.source();
        },
        // Build the backend filter payload from the reusable user filter organism state.
        buildMemberFilters(): UserFilter[] {
            const filters: UserFilter[] = [];
            const normalizedSearchText = this.userFilters.search.trim();

            if (normalizedSearchText.length >= 3) {
                filters.push({
                    fieldKey: MEMBERS_SEARCH_FIELD_KEY,
                    value: normalizedSearchText,
                    operator: 'ILIKE',
                });
            }

            if (this.userFilters.createdAt?.value?.startDate) {
                filters.push({
                    fieldKey: MEMBERS_CREATED_AT_FIELD_KEY,
                    value: this.serializeDateFilterValue(this.userFilters.createdAt.value),
                    operator: this.userFilters.createdAt.operator,
                });
            }

            if ((this.userFilters.status?.values || []).length > 0) {
                filters.push({
                    fieldKey: MEMBERS_STATUS_FIELD_KEY,
                    value: this.userFilters.status.values.map((option) => option.Value).join(','),
                    operator: 'IN',
                });
            }

            if ((this.userFilters.currentPlanId?.values || []).length > 0) {
                filters.push({
                    fieldKey: MEMBERS_CURRENT_PLAN_ID_FIELD_KEY,
                    value: this.userFilters.currentPlanId.values.map((option) => option.Value).join(','),
                    operator: 'IN',
                });
            }

            (this.userFilters.moreFilters || []).forEach((moreFilter) => {
                const hasScalarValue = moreFilter.value !== null && moreFilter.value !== '';
                const hasRangeValue =
                    hasScalarValue && moreFilter.secondValue !== null && moreFilter.secondValue !== '';
                const hasArrayValue = (moreFilter.values || []).length > 0;

                if (
                    (moreFilter.operator === 'BETWEEN' && hasRangeValue) ||
                    (moreFilter.fieldType === 'multiselect' && hasArrayValue) ||
                    (moreFilter.operator !== 'BETWEEN' && moreFilter.fieldType !== 'multiselect' && hasScalarValue)
                ) {
                    filters.push({
                        fieldKey: moreFilter.fieldKey,
                        value: this.serializeMoreFilterValue(moreFilter),
                        operator: moreFilter.operator,
                    });
                }
            });

            return filters;
        },
        serializeMoreFilterValue(filter: UserFilterValue['moreFilters'][number]): string {
            if (filter.fieldType === 'date') {
                const startTimestamp = this.normalizeDateToUnixTimestamp(filter.value);
                const endTimestamp = this.normalizeDateToUnixTimestamp(filter.secondValue);

                if (startTimestamp === null) {
                    return '';
                }

                return endTimestamp !== null ? `${startTimestamp},${endTimestamp}` : `${startTimestamp}`;
            }

            if (filter.fieldType === 'multiselect') {
                return filter.values.map((option) => option.Value).join(',');
            }

            if (filter.operator === 'BETWEEN') {
                return `${filter.value},${filter.secondValue}`;
            }

            return String(filter.value);
        },
        buildMembersFilterRequest(offset = 0, limit = this.perPage || MEMBERS_FILTER_PAGE_SIZE): UsersFilterRequest {
            return {
                filters: this.buildMemberFilters(),
                orderByFieldKey: this.orderByFieldKey,
                orderDirection: this.orderDirection,
                limit,
                offset,
            };
        },
        getCsvExportColumns(): CsvExportColumnDefinition[] {
            const selectedExportColumns = this.selectedFields.map((field) => ({
                sourceKey: field.key,
                csvKey: this.normalizeCsvColumnKey(field.key),
            }));

            // Include the backend user identifier even when the table keeps it hidden.
            return [
                {
                    sourceKey: 'object.ID',
                    csvKey: 'ID',
                },
                ...selectedExportColumns.filter((field) => field.sourceKey !== 'object.ID'),
            ];
        },
        normalizeCsvColumnKey(fieldKey: string): string {
            if (fieldKey.startsWith('object.')) {
                return fieldKey.replace(/^object\./, '');
            }

            if (fieldKey.startsWith('customFieldValues.')) {
                return fieldKey.replace(/^customFieldValues\./, '');
            }

            return fieldKey;
        },
        getNestedValue(source: Record<string, unknown> | null | undefined, path: string): unknown {
            return path.split('.').reduce<unknown>((currentValue, segment) => {
                if (!currentValue || typeof currentValue !== 'object') {
                    return undefined;
                }

                return (currentValue as Record<string, unknown>)[segment];
            }, source);
        },
        formatMemberStatus(status: unknown): string {
            return this.statusTypes[Number(status) || 0] || '';
        },
        formatMemberSalutation(salutation: unknown): string {
            if (salutation === 'x') {
                return this.$t('labels.nonbinary');
            }

            if (salutation === 'f') {
                return this.$t('labels.female');
            }

            if (salutation === 'm') {
                return this.$t('labels.male');
            }

            return this.$t('labels.prefernottosay');
        },
        formatMemberDate(value: unknown): string {
            const timestamp = Number(value || 0);
            if (!timestamp || timestamp <= 946684800) {
                return '';
            }

            return formattedDate(timestamp, 'exact', this.$i18n.locale, '');
        },
        normalizeCsvCellValue(value: unknown): string | number | boolean {
            if (value === null || value === undefined) {
                return '';
            }

            if (Array.isArray(value)) {
                return value.map((entry) => this.normalizeCsvCellValue(entry)).join(', ');
            }

            if (typeof value === 'object') {
                return JSON.stringify(value);
            }

            return value as string | number | boolean;
        },
        getUpgradeNameById(upgradeId: unknown): string {
            const normalizedUpgradeId = String(upgradeId || '').trim();
            if (!normalizedUpgradeId) {
                return '';
            }

            return (
                this.upgradeOptions.find((upgradeOption) => String(upgradeOption.Value) === normalizedUpgradeId)
                    ?.Name || ''
            );
        },
        normalizeUpgradeNameList(rawValue: unknown): string[] {
            if (!rawValue) {
                return [];
            }

            if (typeof rawValue === 'string') {
                return rawValue
                    .split(',')
                    .map((value) => value.trim())
                    .filter(Boolean);
            }

            if (Array.isArray(rawValue)) {
                return rawValue.reduce((normalizedNames, entry) => {
                    normalizedNames.push(...this.normalizeUpgradeNameList(entry));
                    return normalizedNames;
                }, [] as string[]);
            }

            if (typeof rawValue === 'object') {
                const rawObject = rawValue as Record<string, unknown>;
                const directName = String(rawObject.Name || rawObject.name || '').trim();

                if (directName) {
                    return [directName];
                }

                const resolvedName = this.getUpgradeNameById(rawObject.ID || rawObject.id);
                return resolvedName ? [resolvedName] : [];
            }

            return [];
        },
        resolveMemberUpgradeNames(member: FilterableCommunityMemberUser, variant: 'current' | 'upcoming'): string {
            const rawMember = member as Record<string, unknown>;
            const directNameField =
                variant === 'current'
                    ? rawMember.CurrentPlanUpgradeNames || rawMember.CurrentPlanUpgradeName
                    : rawMember.UpcomingPlanUpgradeNames || rawMember.UpcomingPlanUpgradeName;
            const directNames = this.normalizeUpgradeNameList(directNameField);

            if (directNames.length > 0) {
                return Array.from(new Set(directNames)).join(', ');
            }

            const directIdField =
                variant === 'current' ? rawMember.CurrentPlanUpgrades : rawMember.UpcomingPlanUpgrades;
            const namesFromIds = this.normalizeUpgradeNameList(directIdField)
                .map((upgradeId) => this.getUpgradeNameById(upgradeId))
                .filter(Boolean);

            if (namesFromIds.length > 0) {
                return Array.from(new Set(namesFromIds)).join(', ');
            }

            // The current plan upgrade list is nested under the plan payload in older member responses.
            if (variant === 'current') {
                const namesFromCurrentPlanExtras = this.normalizeUpgradeNameList(
                    this.getNestedValue(rawMember, 'Plan.plan.Extras') || this.getNestedValue(rawMember, 'Plan.Extras')
                );
                return Array.from(new Set(namesFromCurrentPlanExtras)).join(', ');
            }

            // Upcoming plan upgrades may arrive as an embedded upcoming plan object depending on the endpoint payload.
            const namesFromUpcomingPlanExtras = this.normalizeUpgradeNameList(
                this.getNestedValue(rawMember, 'UpcomingPlan.plan.Extras') ||
                    this.getNestedValue(rawMember, 'UpcomingPlan.Extras')
            );
            return Array.from(new Set(namesFromUpcomingPlanExtras)).join(', ');
        },
        getCsvExportCellValue(member: MembersTableRow, sourceKey: string): string | number | boolean {
            if (sourceKey === 'object.Status') {
                return this.formatMemberStatus(this.getNestedValue(member, sourceKey));
            }

            if (sourceKey === 'object.Profile.Salutation') {
                return this.formatMemberSalutation(this.getNestedValue(member, sourceKey));
            }

            if (
                [
                    'object.CreatedAt',
                    'object.UpdatedAt',
                    'object.LastActivity',
                    'object.CurrentPlanStart',
                    'object.CurrentPlanEnd',
                    'object.UpcomingPlanStart',
                ].includes(sourceKey)
            ) {
                return this.formatMemberDate(this.getNestedValue(member, sourceKey));
            }

            return this.normalizeCsvCellValue(this.getNestedValue(member, sourceKey));
        },
        buildCsvExportRow(
            member: MembersTableRow,
            exportColumns: CsvExportColumnDefinition[]
        ): Record<string, unknown> {
            return exportColumns.reduce(
                (row, column) => ({
                    ...row,
                    [column.csvKey]: this.getCsvExportCellValue(member, column.sourceKey),
                }),
                {} as Record<string, unknown>
            );
        },
        async fetchMembersCsvBatch(source: CancelTokenSource, offset = 0): Promise<UsersFilterResponse> {
            const response = await axios.post<UsersFilterResponse>(
                '/admin/community/member/filter',
                this.buildMembersFilterRequest(offset, MEMBERS_CSV_EXPORT_BATCH_SIZE),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    cancelToken: source.token,
                }
            );

            return response?.data || {};
        },
        showMembersCsvExportModal() {
            this.$refs.csvDownloader?.showProgressModal();
        },
        hideMembersCsvExportModal() {
            this.$refs.csvDownloader?.hideProgressModal();
        },
        waitForMembersCsvProgressDelay(): Promise<void> {
            // Keep the progress modal visible for a short time so each batch update is perceptible before the file download starts.
            const delayRange = MEMBERS_CSV_EXPORT_PROGRESS_DELAY_MAX_MS - MEMBERS_CSV_EXPORT_PROGRESS_DELAY_MIN_MS;
            const delayMs =
                MEMBERS_CSV_EXPORT_PROGRESS_DELAY_MIN_MS + Math.round(Math.random() * Math.max(delayRange, 0));

            return new Promise((resolve) => {
                window.setTimeout(resolve, delayMs);
            });
        },
        getCustomFieldIdentifier(field: CustomMemberField): string {
            return String(field?.Identifier || field?.identifier || '');
        },
        getCustomFieldLabel(field: CustomMemberField): string {
            return String(field?.Label || field?.label || this.getCustomFieldIdentifier(field));
        },
        getCustomFieldSortOrder(field: CustomMemberField): number {
            return Number(field?.SortOrder ?? field?.sort_order ?? 0);
        },
        getCustomFieldInputType(
            field: CustomMemberField
        ): CustomMemberField['InputType'] | CustomMemberField['data_type'] {
            return field?.InputType || field?.data_type;
        },
        sortCustomFields(fields: CustomMemberField[] = []): CustomMemberField[] {
            return [...fields].sort((a, b) => {
                const leftSortOrder = this.getCustomFieldSortOrder(a);
                const rightSortOrder = this.getCustomFieldSortOrder(b);

                if (leftSortOrder === rightSortOrder) {
                    return this.getCustomFieldLabel(a).localeCompare(this.getCustomFieldLabel(b));
                }

                return leftSortOrder - rightSortOrder;
            });
        },
        formatCustomFieldValue(field: CustomMemberField): string {
            const rawValue = field?.Value ?? field?.value;

            if (rawValue === null || rawValue === undefined || rawValue === '') {
                return '';
            }

            if (this.getCustomFieldInputType(field) === 'boolean') {
                return String(rawValue) === 'true' ? this.$t('labels.yes') : this.$t('labels.no');
            }

            if (this.getCustomFieldInputType(field) === 'multiselect') {
                return String(rawValue)
                    .split(',')
                    .map((value) => value.trim())
                    .filter(Boolean)
                    .join(', ');
            }

            return String(rawValue);
        },
        getUserCustomFields(user: FilterableCommunityMemberUser): CustomMemberField[] {
            const fields = user?.Fields;
            return Array.isArray(fields) ? (fields as CustomMemberField[]) : [];
        },
        normalizeCustomFieldDefinition(item: CustomFieldListItem | CustomMemberField): CustomMemberField {
            return 'object' in item && item.object ? item.object : (item as CustomMemberField);
        },
        extractCustomFieldDefinitions(users: FilterableCommunityMemberUser[] = []): CustomMemberField[] {
            const definitionsByIdentifier: Record<string, CustomMemberField> = {};

            users.forEach((user) => {
                this.getUserCustomFields(user).forEach((field: CustomMemberField) => {
                    const identifier = this.getCustomFieldIdentifier(field);
                    if (!identifier || definitionsByIdentifier[identifier]) {
                        return;
                    }

                    definitionsByIdentifier[identifier] = field;
                });
            });

            return this.sortCustomFields(Object.values(definitionsByIdentifier));
        },
        async getAllCustomFields(): Promise<void> {
            try {
                const response = await axios.get('/admin/member/custom-fields?limit=100', { withCredentials: true });
                const objects = response?.data?.objects || [];
                this.customFieldDefinitions = this.sortCustomFields(
                    objects
                        .map((item: CustomFieldListItem | CustomMemberField) =>
                            this.normalizeCustomFieldDefinition(item)
                        )
                        .filter((field: CustomMemberField) => this.getCustomFieldIdentifier(field))
                );
            } catch (error) {
                console.error('Error fetching custom fields:', error);
            }
        },
        normalizeMembers(users: FilterableCommunityMemberUser[] = []): MembersTableRow[] {
            return users.map((user) => ({
                object: {
                    ...user,
                    // Materialize upgrade names on each row so the generic table and CSV export can display readable values.
                    CurrentPlanUpgradeNames: this.resolveMemberUpgradeNames(user, 'current'),
                    UpcomingPlanUpgradeNames: this.resolveMemberUpgradeNames(user, 'upcoming'),
                },
                // Flatten custom fields into stable table keys so the generic CoTable can render them and export them.
                customFieldValues: this.getUserCustomFields(user).reduce((accumulator, field: CustomMemberField) => {
                    const identifier = this.getCustomFieldIdentifier(field);
                    if (identifier) {
                        accumulator[identifier] = this.formatCustomFieldValue(field);
                    }

                    return accumulator;
                }, {} as Record<string, string>),
            }));
        },
        normalizeDateToUnixTimestamp(value: Date | string | number | null | undefined): number | null {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            if (typeof value === 'number') {
                return value > 9999999999 ? Math.floor(value / 1000) : value;
            }

            const parsedDate = new Date(value);
            if (Number.isNaN(parsedDate.getTime())) {
                return null;
            }

            return Math.floor(parsedDate.getTime() / 1000);
        },
        serializeDateFilterValue(dateRange: UserCreatedAtFilterValue['value']): string {
            const startTimestamp = this.normalizeDateToUnixTimestamp(dateRange?.startDate);
            const endTimestamp = this.normalizeDateToUnixTimestamp(dateRange?.endDate);
            if (startTimestamp === null) {
                return '';
            }
            return endTimestamp !== null ? `${startTimestamp},${endTimestamp}` : `${startTimestamp}`;
        },
        normalizeNextOffset(offset: number, response: UsersFilterResponse): number | null {
            const returnedCount = Number(response?.returnedCount || 0);
            const totalCount = Number(response?.totalCount || 0);
            const candidateNextOffset = Number(response?.nextOffset || 0);

            if (returnedCount === 0) {
                return null;
            }

            if (candidateNextOffset > offset && (totalCount === 0 || candidateNextOffset < totalCount)) {
                return candidateNextOffset;
            }

            return null;
        },

        getAllPlans() {
            axios({
                method: 'GET',
                url: '/admin/plan/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const planList = response?.data?.Plans || [];
                    // Normalize plans for CoUserFilter so plan chips and plan filters share the same option shape.
                    this.planOptions = planList
                        .filter((plan) => plan?.ID && plan?.Name)
                        .map((plan) => ({
                            Name: plan.Name,
                            Value: plan.ID,
                        }));
                })
                .catch((error) => {
                    console.error('Error fetching plans:', error);
                });
        },
        getAllPlanUpgrades() {
            axios({
                method: 'GET',
                url: '/admin/extra/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const upgradeList = response?.data?.Extras || [];
                    // Normalize upgrades into the shared filter option shape used by multiselect member filters.
                    this.upgradeOptions = upgradeList
                        .filter((upgrade) => upgrade?.ID && upgrade?.Name)
                        .map((upgrade) => ({
                            Name: upgrade.Name,
                            Value: upgrade.ID,
                        }));
                })
                .catch((error) => {
                    console.error('Error fetching plan upgrades:', error);
                });
        },
        async fetchMembersPage(source: CancelTokenSource, offset = 0): Promise<void> {
            const response = await axios.post<UsersFilterResponse>(
                '/admin/community/member/filter',
                this.buildMembersFilterRequest(offset),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    cancelToken: source.token,
                }
            );

            this.pagesLoaded += 1;

            const users = response?.data?.users || [];
            if (this.customFieldDefinitions.length === 0) {
                this.customFieldDefinitions = this.extractCustomFieldDefinitions(users);
            }
            this.objects = this.normalizeMembers(users);
            this.totalCount = Number(response?.data?.totalCount || users.length || 0);
            this.currentOffset = offset;
            this.nextOffset = this.normalizeNextOffset(offset, response.data || {});
        },
        async listMembers(offset = 0, options: { rememberCurrentOffset?: boolean; resetHistory?: boolean } = {}) {
            const { rememberCurrentOffset = false, resetHistory = false } = options;

            if (this.ongoingRequest != null) {
                this.ongoingRequest.cancel('Operation canceled by new request.');
                this.ongoingRequest = null;
            }

            // Preserve the horizontal table position before the loading state swaps out the scroll container.
            this.preserveMembersTableScrollPosition();
            this.pagesLoading = true;
            this.requestLoading = true;
            this.pagesLoaded = resetHistory ? 0 : this.pagesLoaded;
            const previousOffset = this.currentOffset;

            if (resetHistory) {
                this.previousOffsets = [];
            }

            const source = this.createMembersRequestSource();
            this.ongoingRequest = source;

            try {
                await this.fetchMembersPage(source, offset);
                if (rememberCurrentOffset && previousOffset !== offset) {
                    this.previousOffsets.push(previousOffset);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            } finally {
                if (this.ongoingRequest === source) {
                    this.ongoingRequest = null;
                }
                this.requestLoading = false;
                this.pagesLoading = false;
                this.restoreMembersTableScrollPosition();
            }
        },
        handleTableOrder(order: TableOrderEvent) {
            this.orderByFieldKey = order.key;
            if (order.key.startsWith('object.')) {
                this.orderByFieldKey = order.key.replace('object.', '');
            }
            // map local keys to API field keys
            const keysMap = {
                'Profile.Name': 'First_Name',
                'Profile.BirthDate': 'BirthDate',
                'Profile.Interests': 'Interests',
                'Profile.Bio': 'Bio',
                'Profile.Tags': 'Tags',
                'Profile.Salutation': 'salutation',
                'Address.Company': 'billing_address_company',
                'Address.AdditionalInfo': 'billing_address_additional_info',
                'Address.Address': 'billing_address',
                'Address.PostalCode': 'billing_address_postal_code',
                'Address.City': 'billing_address_city',
                'Address.Country': 'billing_address_country',
                'Address.Phone': 'billing_address_phone',
                'Address.VATNumber': 'billing_address_vat',
                'RegistrationAddress.Company': 'address_company',
                'RegistrationAddress.AdditionalInfo': 'address_additional_info',
                'RegistrationAddress.Address': 'address',
                'RegistrationAddress.PostalCode': 'address_postal_code',
                'RegistrationAddress.City': 'address_city',
                'RegistrationAddress.Country': 'address_country',
                LastActivity: 'last_activity',
            };

            if (keysMap[this.orderByFieldKey]) {
                this.orderByFieldKey = keysMap[this.orderByFieldKey];
            }

            if (this.orderByFieldKey.startsWith('customFieldValues.')) {
                this.orderByFieldKey = this.orderByFieldKey.replace('customFieldValues.', '');
            }

            this.orderDirection = order.asc ? 'ASC' : 'DESC';
            this.syncUserFiltersQuery();
            this.listMembers(0, { resetHistory: true });
        },
        updateSelectedFields(selectedFieldKeys: string[]) {
            this.selectedFieldKeys = selectedFieldKeys;
            this.$store.dispatch('setTablePreference', {
                tableKey: MEMBERS_TABLE_PREFERENCE_KEY,
                preferenceKey: MEMBERS_SELECTED_COLUMNS_PREFERENCE_KEY,
                value: selectedFieldKeys,
            });
        },
        updateSearchFilter() {
            // Reuse the existing filter refresh flow when the page-level search input changes.
            this.userFilters = this.normalizeUserFilters(this.userFilters);
            this.syncUserFiltersQuery();
            this.listMembers(0, { resetHistory: true });
        },
        updateUserFilters(nextFilters: UserFilterValue) {
            this.userFilters = this.normalizeUserFilters(nextFilters);
            this.syncUserFiltersQuery();
            this.listMembers(0, { resetHistory: true });
        },
        loadPreviousPage() {
            if (!this.hasPreviousPage) {
                return;
            }

            const previousOffset = this.previousOffsets.pop();
            if (previousOffset === undefined) {
                return;
            }

            this.listMembers(previousOffset);
        },
        loadNextPage() {
            if (!this.hasNextPage || this.nextOffset === null) {
                return;
            }

            this.listMembers(this.nextOffset, { rememberCurrentOffset: true });
        },
        async downloadCsv() {
            const exportColumns = this.getCsvExportColumns();
            const source = this.createMembersRequestSource();
            const exportRows: Record<string, unknown>[] = [];
            let offset = 0;
            let nextOffset: number | null = 0;

            // Drive the modal progress bar from the current result count before the first export batch returns.
            this.csvExportLoading = true;
            this.csvExportProgressCurrent = 0;
            this.csvExportProgressTotal = this.totalCount || 0;
            this.showMembersCsvExportModal();

            try {
                while (nextOffset !== null) {
                    // The export must request each backend page sequentially because the next offset depends on the previous response.
                    // eslint-disable-next-line no-await-in-loop
                    const response = await this.fetchMembersCsvBatch(source, offset);
                    const users = response?.users || [];
                    const normalizedUsers = this.normalizeMembers(users);

                    if (this.csvExportProgressTotal === 0) {
                        this.csvExportProgressTotal = Number(response?.totalCount || users.length || 0);
                    }

                    normalizedUsers.forEach((member) => {
                        exportRows.push(this.buildCsvExportRow(member, exportColumns));
                    });

                    this.csvExportProgressCurrent = exportRows.length;
                    // Slow the export UI down slightly so users can see the progress value change before the final CSV download begins.
                    // eslint-disable-next-line no-await-in-loop
                    await this.waitForMembersCsvProgressDelay();
                    nextOffset = this.normalizeNextOffset(offset, response);

                    if (nextOffset === null) {
                        break;
                    }

                    offset = nextOffset;
                }

                this.$refs.csvDownloader.exportAsCSV(
                    exportRows,
                    exportColumns.map((column) => column.csvKey)
                );
            } catch (error) {
                console.error(error);
                EventBus.$emit('ERROR', {
                    Message: this.$t('messages.membersCsvExportFailed'),
                    Details: '',
                });
            } finally {
                this.csvExportLoading = false;
                this.hideMembersCsvExportModal();
            }
        },
    },
};
